import { dispatch, getState, select } from '@swf/core/store';
import { fetchJson, fetchText } from '@swf/core/utils/api';

const CRM_FAILOVER_TAG = 'ngc_starscrm_failover';

const fetchCrmFailover = async (zoneId: string): Promise<string> => {
  await dispatch.resolver.fetchTag({ tag: CRM_FAILOVER_TAG });
  try {
    const { url } = select.resolver.getTag(getState(), CRM_FAILOVER_TAG);
    const { content, contentUrl, suppressDefault } = await fetchJson(`${url}${zoneId}.json`);
    if (!suppressDefault) {
      return content ? content : await fetchText(contentUrl);
    } else {
      return '';
    }
  } catch {
    return '';
  }
};

export default fetchCrmFailover;
